export let loadUploadUrl;

export function setUpload(uploadService) {
    loadUploadUrl = uploadService.loadUploadUrl;
}
